import React from 'react';
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
// import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded'
import {
    Button,
} from '@themesberg/react-bootstrap'
import Tooltip from "@mui/material/Tooltip";


const ActionMenu = (props) => {
    const { gameCategory, categoryType, categoryEnumn, gameCategoryId, categoryData, handleShow, isHidden, isActive, name, index, handleStatusShow, handleDeleteCategory, onHandleCategory, handleViewGames, isCategoryValut } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl)
    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    return (
        <>

            <>
                <Button
                    variant='btn text-btn'
                    id='basic-button'
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup='true'
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                >
                    <MoreVertRoundedIcon />
                </Button>
                <Menu
                    id='basic-menu'
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}
                >
                    <MenuItem onClick={handleClose}>
                        <Button
                            variant='btn text-btn'
                            onClick={() =>
                                handleViewGames(gameCategory[index])
                            }
                            hidden={isHidden({
                                module: {
                                    key: 'CasinoCategory',
                                    value: 'R',
                                },
                            })}
                        >
                            <RemoveRedEyeRoundedIcon />
                            <span className='text'>View Games</span>
                        </Button>
                    </MenuItem>

                    {!isCategoryValut && <MenuItem onClick={handleClose}>
                        <Button
                            variant='btn text-btn'
                            onClick={() =>
                                handleShow(
                                    'Edit',
                                    gameCategory[index],
                                )
                            }
                            hidden={isHidden({
                                module: {
                                    key: 'CasinoCategory',
                                    value: 'U',
                                },
                            })}
                        >
                            <BorderColorRoundedIcon />
                            <span className='text'>Edit</span>
                        </Button>
                    </MenuItem>}

                    {/* <MenuItem onClick={handleClose}>
                    
                        <Button
                            variant='btn text-btn'
                            onClick={() =>
                                handleStatusShow(
                                    gameCategoryId,
                                    isActive,
                                    name,
                                )
                            }
                            hidden={isHidden({
                                    module: {
                                        key: 'CasinoManagement',
                                        value: 'T',
                                    },
                                })
                            }
                            >
                            {
                            !isActive ? 
                                <>
                                    <CheckCircleRoundedIcon />
                                    <span className='text'>Set Status Active</span>
                                </>
                                :
                                <>
                                    <CancelRoundedIcon />
                                    <span className='text'>Set Status In-Active</span>
                                </>
                            }
                       
                        </Button>
                </MenuItem> */}
                    {!isCategoryValut && <MenuItem onClick={handleClose}>
                        <Button
                            variant='btn text-btn'
                            onClick={() =>
                                handleDeleteCategory(
                                    gameCategoryId,
                                    isActive,
                                    name,
                                )
                            }
                            hidden={isHidden({
                                module: {
                                    key: 'CasinoCategory',
                                    value: 'D',
                                },
                            })}
                        >
                            <DeleteForeverOutlinedIcon />
                            <span className='text'>Delete</span>
                        </Button>
                    </MenuItem>}

                    {/* category options  */}


                    <MenuItem onClick={handleClose}>
                        <Tooltip
                            title={
                                categoryType === "vault"
                                    ? "Cannot convert from  Category Vault to Featured Category"
                                    : ""
                            }
                            arrow
                        >
                            <span> {/* wrapper so Tooltip still works when button is disabled */}
                                <Button
                                    variant="btn text-btn"
                                    onClick={() =>
                                        onHandleCategory({
                                            categoryData,
                                            gameCategoryId,
                                            isActive,
                                            name,
                                        })
                                    }
                                    hidden={isHidden({
                                        module: {
                                            key: "CasinoCategory",
                                            value: "U",
                                        },
                                    })}
                                    disabled={categoryType === "vault"} // disable if vault
                                >
                                    <CheckCircleRoundedIcon />
                                    <span className="text">
                                        {categoryType === "featured"
                                            ? `Set as ${categoryEnumn.vault}`
                                            : `Set as ${categoryEnumn.featuredCategory}`}
                                    </span>
                                </Button>
                            </span>
                        </Tooltip>
                    </MenuItem>




                </Menu></>
        </>
    )
};

export default ActionMenu;